module.exports = __webpack_public_path__ + "img/Posts-icon.5c7e3f5e.svg";